import { useEffect } from 'react';

const useSEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage, 
  ogUrl,
  canonicalUrl,
  jsonLd 
}) => {
  useEffect(() => {
    // Actualizar el título de la página
    if (title) {
      document.title = title;
    }

    // Función para actualizar o crear meta tags
    const updateMetaTag = (selector, content, property = 'content') => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute(property, content);
      } else {
        element = document.createElement('meta');
        if (selector.includes('name=')) {
          element.name = selector.match(/name="([^"]+)"/)[1];
        } else if (selector.includes('property=')) {
          element.setAttribute('property', selector.match(/property="([^"]+)"/)[1]);
        }
        element.content = content;
        document.head.appendChild(element);
      }
    };

    // Función para actualizar link tags (canonical)
    const updateLinkTag = (rel, href) => {
      let element = document.querySelector(`link[rel="${rel}"]`);
      if (element) {
        element.href = href;
      } else {
        element = document.createElement('link');
        element.rel = rel;
        element.href = href;
        document.head.appendChild(element);
      }
    };

    // Actualizar meta tags básicos
    if (description) {
      updateMetaTag('meta[name="description"]', description);
    }
    
    if (keywords) {
      updateMetaTag('meta[name="keywords"]', keywords);
    }

    // Open Graph tags
    if (title) {
      updateMetaTag('meta[property="og:title"]', title);
    }
    
    if (description) {
      updateMetaTag('meta[property="og:description"]', description);
    }
    
    if (ogImage) {
      updateMetaTag('meta[property="og:image"]', ogImage);
    }
    
    if (ogUrl) {
      updateMetaTag('meta[property="og:url"]', ogUrl);
    }

    // Twitter tags
    if (title) {
      updateMetaTag('meta[name="twitter:title"]', title);
    }
    
    if (description) {
      updateMetaTag('meta[name="twitter:description"]', description);
    }
    
    if (ogImage) {
      updateMetaTag('meta[name="twitter:image"]', ogImage);
    }

    // URL canónica
    if (canonicalUrl) {
      updateLinkTag('canonical', canonicalUrl);
    }

    // JSON-LD para datos estructurados
    if (jsonLd) {
      let script = document.querySelector('script[type="application/ld+json"]');
      if (script) {
        script.textContent = JSON.stringify(jsonLd);
      } else {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(jsonLd);
        document.head.appendChild(script);
      }
    }

  }, [title, description, keywords, ogImage, ogUrl, canonicalUrl, jsonLd]);
};

export default useSEO;
